export default {output:'PRODUCTION'};